import { Backdrop, Box, Card, CircularProgress } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import React, { use, useEffect, useState } from "react";
import {
  useGetFinancialAccountsQuery,
  useLazyGetFinancialAccountsQuery,
} from "../../redux/Slices/financial-accountsApi";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import AccountTableData from "./AccountTableData";
import AddCommissionModal from "components/AddCommissionModel";
import AddNewAccountModal from "components/AddNewAccountModel";

const Accounts = () => {
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [Accounts, setAccounts] = useState([]);
  const [getFinancialAccounts, { isLoading: isFetchingAccounts }] =
    useLazyGetFinancialAccountsQuery();
  const [modalOpen, setModalOpen] = useState(false);
  const [currentAccount, setCurrentAccount] = useState(null);

  const handleEditClick = (account) => {
    setCurrentAccount(account);
    setModalOpen(true);
  };

  useEffect(() => {
    const fetchAccounts = async () => {
      const accountsData = await getFinancialAccounts(page).unwrap();
      setAccounts(accountsData);
      setPage(accountsData?.meta?.current_page);
      setTotalPages(accountsData?.meta?.last_page);
    };
    fetchAccounts();
  }, [page]);

  const { columns, rows } = AccountTableData(Accounts?.data, handleEditClick, getFinancialAccounts);

  return (
    <>
      <Backdrop open={isFetchingAccounts} sx={{ zIndex: 2000, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <AddNewAccountModal
        open={modalOpen}
        onClose={() => {
          setModalOpen(false);
          setCurrentAccount(null);
        }}
        initialData={currentAccount}
      />

      <MDBox pt={6} pb={3}>
        <Card>
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            borderRadius="lg"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              background: "linear-gradient(90deg, #ca9937, #e0b15a)",
              boxShadow: 3,
            }}
          >
            <MDTypography variant="h6" color="white">
              قائمة الحسابات
            </MDTypography>
            <MDButton
              variant="contained"
              color="white"
              startIcon={<AddIcon />}
              sx={{ color: "white" }}
              onClick={() => setModalOpen(true)}
            >
              إنشاء حساب
            </MDButton>
          </MDBox>
          <Box sx={{ mt: 3, px: 2 }}>
            <DataTable
              table={{ columns, rows: rows || [] }}
              isSorted={false}
              entriesPerPage={false}
              showTotalEntries={true}
              noEndBorder
              sx={{
                "& .MuiTable-root": { minWidth: 1000 },
                "& .MuiTableCell-root": {
                  py: 1.5,
                  borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
                },
                "& .MuiTableHead-root": {
                  backgroundColor: (theme) => theme.palette.grey[100],
                },
              }}
            />
           
          </Box>
        </Card>
      </MDBox> 
      <MDBox display="flex" justifyContent="center" mt={4} pb={4} px={2}>
              <MDButton
                onClick={() =>
                  setPage((prev) => {
                    if (prev === 1) {
                      return prev;
                    }
                    return prev - 1;
                  })
                }
                disabled={page === 1}
                sx={{
                  background: "linear-gradient(90deg, #ca9937, #e0b15a)",
                  color: "white",
                  borderRadius: "50%",
                  width: "50px",
                  height: "50px",
                  minWidth: "50px",
                  mx: 1,
                  "&:hover": {
                    background: "linear-gradient(90deg, #b6842f, #d39d45)",
                  },
                }}
              >
                <ArrowForwardIcon />
              </MDButton>

              <MDTypography
                variant="button"
                color="text"
                sx={{ display: "flex", alignItems: "center", mx: 3, fontWeight: "bold" }}
              >
                 {page}
              </MDTypography>

              <MDButton
                onClick={() =>
                  setPage((prev) => {
                    if (prev === totalPages) {
                      return prev;
                    }
                    return prev + 1;
                  })
                }
                disabled={page === totalPages}
                sx={{
                  background: "linear-gradient(90deg, #ca9937, #e0b15a)",
                  color: "white",
                  borderRadius: "50%",
                  width: "50px",
                  height: "50px",
                  minWidth: "50px",
                  mx: 1,
                  "&:hover": {
                    background: "linear-gradient(90deg, #b6842f, #d39d45)",
                  },
                }}
              >
                <ArrowBackIcon />
              </MDButton>
            </MDBox>
    </>
  );
};

export default Accounts;
